import React from "react";
import { Navigate } from "react-router-dom";

// Component Imports
import Dashboard from "./containers/Dashboard/Dashboard";
import Projects from "./containers/Project/Projects";
import ProjectCreate from "./containers/Project/Project-Create";
import Suppliers from "./containers/Supplier/Suppliers";
import SupplierCreate from "./containers/Supplier/Supplier-Create";
import Structures from "./containers/Structure/Structures";
import StructureCreate from "./containers/Structure/Structure-Create";
import ProjectFile from "./containers/ProjectFile/ProjectFile";
import ProjectFileCreate from "./containers/ProjectFile/ProjectFile-Create";
import User from "./containers/User/Users";
import UserCreate from "./containers/User/User-Create";
import BatchReport from "./containers/BatchReport/BatchReport";
import Login from "./containers/Login/Login";

const USER_ROLES = { superadmin: "superadmin", admin: "admin", user: "user" };

const AuthRoutes = [
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/",
    component: () => <Navigate to="/login" replace />,
  },
  {
    path: "*",
    component: () => <Navigate to="/login" replace />,
  },
];

const CommonRoutes = [
  {
    path: "/dashboard",
    component: Dashboard,
  },
  {
    path: "/",
    component: () => <Navigate to="/dashboard" replace />,
  },
  {
    path: "*",
    component: () => <Navigate to="/dashboard" replace />,
  },
];

const SuperadminRoutes = [
  {
    path: "projects/edit/:projectId",
    component: ProjectCreate,
  },
  {
    path: "projects/create",
    component: ProjectCreate,
  },
  {
    path: "projects/:projectId",
    component: ProjectCreate,
  },
  {
    path: "view-projects-superadmin",
    component: Projects,
  },
  {
    path: "projects",
    component: Projects,
  },
  {
    path: "project/:projectId/supplier/create",
    component: SupplierCreate,
  },
  {
    path: "project/:projectId/supplier/:supplierId/edit",
    component: SupplierCreate,
  },
  {
    path: "project/:projectId/supplier/:supplierId/detail",
    component: SupplierCreate,
  },
  {
    path: "project/:projectId/supplier",
    component: Suppliers,
  },
  {
    path: "suppliers",
    component: Suppliers,
  },
  {
    path: "project/:projectId/structure/create",
    component: StructureCreate,
  },
  {
    path: "project/:projectId/structure/:structureId/edit",
    component: StructureCreate,
  },
  {
    path: "project/:projectId/structure/:structureId/detail",
    component: StructureCreate,
  },
  {
    path: "project/:projectId/structure",
    component: Structures,
  },
  {
    path: "structures",
    component: Structures,
  },
  {
    path: "project/:projectId/file/create",
    component: ProjectFileCreate,
  },
  {
    path: "project/:projectId/file/:projectFileId/edit",
    component: ProjectFileCreate,
  },
  {
    path: "project/:projectId/file/:projectFileId/detail",
    component: ProjectFileCreate,
  },
  {
    path: "project/:projectId/file/:projectFileId/clone",
    component: ProjectFileCreate,
  },
  {
    path: "project/:projectId/file",
    component: ProjectFile,
  },
  {
    path: "file",
    component: ProjectFile,
  },
  {
    path: "project/:projectId/batchreport",
    component: BatchReport,
  },
  {
    path: "users/create",
    component: UserCreate,
  },
  {
    path: "users/:userId/edit",
    component: UserCreate,
  },
  {
    path: "users/:userId/detail",
    component: UserCreate,
  },
  {
    path: "users",
    component: User,
  },
  ...CommonRoutes,
];

const AdminRoutes = [
  {
    path: "projects/edit/:projectId",
    component: ProjectCreate,
  },
  {
    path: "projects/create",
    component: ProjectCreate,
  },
  {
    path: "projects/:projectId",
    component: ProjectCreate,
  },
  {
    path: "view-projects-superadmin",
    component: Projects,
  },
  {
    path: "projects",
    component: Projects,
  },
  {
    path: "project/:projectId/supplier/create",
    component: SupplierCreate,
  },
  {
    path: "project/:projectId/supplier/:supplierId/edit",
    component: SupplierCreate,
  },
  {
    path: "project/:projectId/supplier/:supplierId/detail",
    component: SupplierCreate,
  },
  {
    path: "project/:projectId/supplier",
    component: Suppliers,
  },
  {
    path: "suppliers",
    component: Suppliers,
  },
  {
    path: "project/:projectId/structure/create",
    component: StructureCreate,
  },
  {
    path: "project/:projectId/structure/:structureId/edit",
    component: StructureCreate,
  },
  {
    path: "project/:projectId/structure/:structureId/detail",
    component: StructureCreate,
  },
  {
    path: "project/:projectId/structure",
    component: Structures,
  },
  {
    path: "structures",
    component: Structures,
  },
  {
    path: "project/:projectId/file/create",
    component: ProjectFileCreate,
  },
  {
    path: "project/:projectId/file/:projectFileId/edit",
    component: ProjectFileCreate,
  },
  {
    path: "project/:projectId/file/:projectFileId/detail",
    component: ProjectFileCreate,
  },
  {
    path: "project/:projectId/file/:projectFileId/clone",
    component: ProjectFileCreate,
  },
  {
    path: "project/:projectId/file",
    component: ProjectFile,
  },
  {
    path: "file",
    component: ProjectFile,
  },
  {
    path: "project/:projectId/batchreport",
    component: BatchReport,
  },
  {
    path: "users/create",
    component: UserCreate,
  },
  {
    path: "users/:userId/edit",
    component: UserCreate,
  },
  {
    path: "users/:userId/detail",
    component: UserCreate,
  },
  {
    path: "users",
    component: User,
  },
  ...CommonRoutes,
];

const UserRoutes = [
  {
    path: "projects/edit/:projectId",
    component: ProjectCreate,
  },
  {
    path: "projects/create",
    component: ProjectCreate,
  },
  {
    path: "projects/:projectId",
    component: ProjectCreate,
  },
  {
    path: "view-projects-superadmin",
    component: Projects,
  },
  {
    path: "projects",
    component: Projects,
  },
  {
    path: "project/:projectId/supplier/create",
    component: SupplierCreate,
  },
  {
    path: "project/:projectId/supplier/:supplierId/edit",
    component: SupplierCreate,
  },
  {
    path: "project/:projectId/supplier/:supplierId/detail",
    component: SupplierCreate,
  },
  {
    path: "project/:projectId/supplier",
    component: Suppliers,
  },
  {
    path: "suppliers",
    component: Suppliers,
  },
  {
    path: "project/:projectId/structure/create",
    component: StructureCreate,
  },
  {
    path: "project/:projectId/structure/:structureId/edit",
    component: StructureCreate,
  },
  {
    path: "project/:projectId/structure/:structureId/detail",
    component: StructureCreate,
  },
  {
    path: "project/:projectId/structure",
    component: Structures,
  },
  {
    path: "structures",
    component: Structures,
  },
  {
    path: "project/:projectId/file/create",
    component: ProjectFileCreate,
  },
  {
    path: "project/:projectId/file/:projectFileId/edit",
    component: ProjectFileCreate,
  },
  {
    path: "project/:projectId/file/:projectFileId/detail",
    component: ProjectFileCreate,
  },
  {
    path: "project/:projectId/file/:projectFileId/clone",
    component: ProjectFileCreate,
  },
  {
    path: "project/:projectId/file",
    component: ProjectFile,
  },
  {
    path: "file",
    component: ProjectFile,
  },
  {
    path: "project/:projectId/batchreport",
    component: BatchReport,
  },
  ...CommonRoutes,
];

export { CommonRoutes as default };
export { USER_ROLES, AuthRoutes, SuperadminRoutes, AdminRoutes, UserRoutes };
